import { type ThunkDispatch, type UnknownAction } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { withReduxStateSync } from 'redux-state-sync';

import Brand from './brand/reducer';
import Carrier from './carrier/reducer';
import Categories from './categories/reducer';
import Category from './category/reducer';
import ComparisonPortal from './comparison-portal/reducer';
import Config from './config/reducer';
import Countries from './countries/reducer';
import Country from './country/reducer';
import CountryLanguages from './country-languages/reducer';
import CrmCustomerDetail from './crm-customer-detail/reducer';
import CrmCustomers from './crm-customers/reducer';
import Currency from './currency/reducer';
import Dashboard from './dashboard/reducer';
import Delivery from './delivery/reducer';
import Discount from './discount/reducer';
import Downloader from './downloader/reducer';
import Ebay from './ebay/reducer';
import EmailValidator from './email-validator/reducer';
import Facebook from './facebook/reducer';
import FeatureFlags from './feature-flags/reducer';
import GiftRegistry from './gift-registry/reducer';
import Language from './language/reducer';
import MarketingConsentCampaign from './marketing-consent-campaign/reducer';
import Messenger from './messenger/reducer';
import Order from './order/reducer';
import Orders from './orders/reducer';
import Packets from './packets/reducer';
import Product from './product/reducer';
import ProductSafety from './product-safety/reducer';
import Products from './products/reducer';
import Properties from './properties/reducer';
import Property from './property/reducer';
import Report from './report/reducer';
import Search from './search/reducer';
import Settings from './settings/reducer';
import SocialNetworks from './social-networks/reducer';
import Tags from './tags/reducer';
import User from './user/reducer';
import Warehouse from './warehouse/reducer';
import WarehouseOrder from './warehouse-order/reducer';
import Watchdog from './watchdog/reducer';
import WebAnalyticsInsights from './web-analytics-insights/reducer';
import Withdrawal from './withdrawal/reducer';

const combinedReducers = combineReducers({
  Brand,
  Carrier,
  CrmCustomerDetail,
  CrmCustomers,
  Categories,
  Category,
  ComparisonPortal,
  Config,
  Countries,
  Country,
  CountryLanguages,
  Currency,
  Dashboard,
  Delivery,
  Discount,
  Downloader,
  Ebay,
  EmailValidator,
  Facebook,
  FeatureFlags,
  GiftRegistry,
  Language,
  MarketingConsentCampaign,
  Messenger,
  Order,
  Orders,
  Packets,
  Product,
  ProductSafety,
  Products,
  Properties,
  Property,
  Report,
  Search,
  Settings,
  SocialNetworks,
  Tags,
  User,
  Warehouse,
  WarehouseOrder,
  Watchdog,
  WebAnalyticsInsights,
  Withdrawal,
});

const rootReducer = withReduxStateSync(combinedReducers);

export type RootState = ReturnType<typeof combinedReducers>;
export type AppDispatch = ThunkDispatch<RootState, undefined, UnknownAction>;

export default rootReducer;
